const theme = {
  colors: {
    primary: 'var(--action-primary)',
    primaryLight: 'var(--color-blue-500)',
    secondary: 'var(--surface-sunken)',
    accent: 'var(--action-primary)',
    white: 'var(--surface-card)',
    background: 'var(--surface-page)',
    lightGray: 'var(--line-hairline)',
    darkGray: 'var(--text-muted)',
    text: 'var(--text-body)',
    textLight: 'var(--text-muted)',
    success: 'var(--color-success)',
    warning: 'var(--color-warning)',
    error: 'var(--color-danger)',
  },
  fonts: {
    heading: 'var(--font-display)',
    body: 'var(--font-sans)',
  },
  breakpoints: {
    mobile: '30rem',
    tablet: '48rem',
    desktop: '64rem',
    desktopUp: '64.0625rem',
    wide: '75rem',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
    xxxl: '4rem',
  },
  shadows: {
    sm: 'var(--shadow-sm)',
    md: 'var(--shadow-md)',
    lg: 'var(--shadow-lg)',
    xl: 'var(--shadow-xl)',
  },
  gradients: {
    primary: 'var(--gradient-primary)',
    glass: 'var(--surface-glass)',
    orange: 'var(--gradient-accent)',
  },
};

export default theme;
